import React from 'react';
import { CheckIcon, GlobeIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Reassurance } from './Reassurance';
import { CHECKOUT_URL, incluye } from '../data/content';
export function PriceSection() {
  return <section id="precio" className="w-full scroll-mt-2 bg-brand-deep px-4 py-9 sm:px-6 sm:py-12" data-id="element-138" data-mp="39gelsthvu8v7">
      <div className="mx-auto max-w-md sm:max-w-lg" data-id="element-139" data-mp="30ht8bcr9pk1a">
        <h2 className="text-center font-display text-[1.1rem] font-extrabold uppercase leading-tight text-white sm:text-2xl" data-id="element-140" data-mp="30im63o890z7a">
          Todo lo que necesitas para empezar tu reset, hoy.
        </h2>

        <div className="mt-4 rounded-2xl border border-accent/40 bg-white/[0.07] p-4 shadow-2xl shadow-black/30 sm:p-6" data-id="element-141" data-mp="2qketfhkzt3b3">
          <p className="text-center font-display text-base font-extrabold uppercase tracking-wide text-white sm:text-xl" data-id="element-142" data-mp="2mk4ng4x7acw8">
            Metabolismo Reset
          </p>

          <ul className="mt-3 grid grid-cols-2 gap-x-3 gap-y-1.5 text-left" data-id="element-143" data-mp="krq554qqv6fa">
            {incluye.map(item => <li key={item} className="flex items-start gap-1.5 text-[0.78rem] leading-tight text-violet-100 sm:text-sm" data-id="element-144" data-mp="1mh1792scv69e">
                <CheckIcon className="mt-px h-3.5 w-3.5 shrink-0 text-accent" aria-hidden="true" data-id="element-145" data-mp="1dipeov7xhyeb" />
                {item}
              </li>)}
          </ul>

          <div className="mt-4 border-t border-white/15 pt-4 text-center" data-id="element-146" data-mp="259n8y3py1r1w">
            <p className="font-display text-[0.7rem] font-extrabold uppercase tracking-wider text-violet-300/70" data-id="element-147" data-mp="2a8gcp4ffi3ov">
              Antes <span className="line-through" data-id="element-148" data-mp="1wg0cschtqls6">USD 157</span>
            </p>
            <p className="mt-1 font-display text-[2.9rem] font-black leading-none tracking-tight text-white sm:text-5xl" data-id="element-149" data-mp="20hlmxq2z4lyo">
              USD 12.99
            </p>
            <p className="mt-1.5 font-display text-[0.72rem] font-extrabold uppercase tracking-[0.2em] text-amber-400" data-id="element-150" data-mp="2o64vm6pxr0ra">
              Pago único
            </p>
            <p className="mx-auto mt-2.5 inline-flex items-center gap-1.5 rounded-full border border-white/20 bg-white/10 px-3 py-1 text-[0.72rem] font-medium text-violet-100 sm:text-xs" data-id="element-151" data-mp="32tdapimd7q8j">
              <GlobeIcon className="h-3.5 w-3.5 text-accent" aria-hidden="true" data-id="element-152" data-mp="2tsx8sdl9sr5s" />
              Paga en tu moneda local
            </p>
          </div>

          <div className="mt-4" data-id="element-153" data-mp="2jvsn0evc6xpi">
            <CtaButton href={CHECKOUT_URL} external location="precio" data-id="element-154" data-mp="2jw2cm1cgz2uo">
              Sí, quiero empezar mi reset
            </CtaButton>
          </div>

          <Reassurance className="mt-2.5" tone="dark" items={['Acceso inmediato', '100% digital', 'Sin suscripciones']} data-id="element-155" data-mp="2f39a7k4h46lr" />

          <div className="mt-3 flex gap-2 rounded-lg border border-white/15 bg-white/5 px-3 py-2.5 text-left" data-id="element-156" data-mp="265yyxyrnohgu">
            <ShieldCheckIcon className="mt-px h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-157" data-mp="214jcq3dqs4wv" />
            <p className="text-[0.75rem] leading-snug text-violet-100" data-id="element-158" data-mp="1m2jkygr1en4a">
              <strong className="font-display font-extrabold uppercase text-white" data-id="element-159" data-mp="1m4du6xsy4qsj">
                Pruébalo 7 días.
              </strong>{' '}
              Si el método no es para ti, puedes solicitar la devolución según
              las condiciones de garantía.
            </p>
          </div>
        </div>
      </div>
    </section>;
}